import React from 'react';
import styled from 'styled-components';

import { Body } from 'src/presentation/components/forms/Layout';
import { Iframe } from 'src/presentation/components/pages/glados/components/Iframe';
import { Spinner } from 'src/presentation/components/pages/shared/Spinner';
import useIframeSrc from 'src/presentation/components/pages/glados/actionAdapters/hooks/useIframeSrc';
import { useListenMessage } from 'src/presentation/components/pages/glados/actionAdapters/hooks/useListenMessage';
import useRouter from 'src/presentation/hooks/useRouter';

const FullPageModalIFramaContent = ({ root, srcPath }) => {
  const { srcUrl, loading, handleIframeLoad, handleIframeError } = useIframeSrc();
  const { history } = useRouter();

  const hash = window.location.hash;

  const iframeSrc = `${srcUrl}${srcPath}?inIframe=true${hash ? `#${hash.slice(1)}` : ''}`;

  const handleReturnToAppAction = event => {
    event.data.type === 'returnToAppAction' && history.push(`${root}`);
  };

  useListenMessage(['returnToAppAction'], handleReturnToAppAction);

  return (
    <StyledBody>
      {loading && <Spinner />}
      {srcUrl && (
        <Iframe
          src={iframeSrc}
          loading={loading}
          handleIframeLoad={handleIframeLoad}
          handleIframeError={handleIframeError}
        />
      )}
    </StyledBody>
  );
};

const StyledBody = styled(Body)`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 100vh;
  max-width: unset;
  overflow: hidden;
  padding: 0;
  width: 100%;
`;

export default FullPageModalIFramaContent;
